export function capitalize(str: string) {
    if (typeof str !== 'string' || str.length < 1) {
        return str;
    } else {
        return str[0].toUpperCase() + str.substr(1);
    }
}
